import { Breadcrumb } from '@domains/breadcrumbs';

export const mockNewsViewBreadcrumbs: Breadcrumb[] = [
    {
        caption: 'Акции и новости',
    },
];
